import { Injectable } from '@angular/core';

import { patch } from '@ngxs/store/operators';
import { Action, ActionType, getActionTypeFromInstance, State, StateContext } from '@ngxs/store';

import { ApiSetMetadata } from './api-state.actions';
import { createApiMetadataSelector } from './api-state.utilities';
import { API_STATE_TOKEN, ApiStateModel } from './api-state.models';
import { ApiFilterValues } from '@app/core/models/api.models';

@Injectable()
@State<ApiStateModel>({
  name: API_STATE_TOKEN,
  defaults: {
    metadata: {},
  },
})
export class ApiState {
  static loading(action: ActionType) {
    return createApiMetadataSelector(action, 'loading');
  }

  static noData(action: ActionType) {
    return createApiMetadataSelector(action, 'noData');
  }

  static firstLoad(action: ActionType) {
    return createApiMetadataSelector(action, 'firstLoad');
  }

  static pagination(action: ActionType) {
    return createApiMetadataSelector(action, 'pagination');
  }

  static total(action: ActionType) {
    return createApiMetadataSelector(action, 'total');
  }

  static canLoadMore(action: ActionType) {
    return createApiMetadataSelector(action, 'canLoadMore');
  }

  static search(action: ActionType) {
    return createApiMetadataSelector(action, 'search', '');
  }

  static sortValues(action: ActionType) {
    return createApiMetadataSelector(action, 'sortValues');
  }

  static filterValues<T extends object = object>(action: ActionType): (state: ApiStateModel) => ApiFilterValues<T> {
    return createApiMetadataSelector(action, 'filterValues');
  }

  static searchValues(action: ActionType) {
    return createApiMetadataSelector(action, 'searchValues');
  }

  static trackById(action: ActionType) {
    return createApiMetadataSelector(action, 'trackById');
  }

  @Action(ApiSetMetadata)
  apiSetMetadata({ setState }: StateContext<ApiStateModel>, { action, metadata }: ApiSetMetadata): void {
    setState(patch({ metadata: patch({ [getActionTypeFromInstance(action)]: metadata }) }));
  }
}
